import React from 'react';
import { Loader, BaasicTable, BaasicModal, BaasicConfirmModal } from 'core/components';
import { LinkOrderLine } from 'modules/order/pages';
import { defaultTemplate } from 'core/hoc';

const OrderLinesListTemplate = ({
	viewStore,
	viewStore: { loading, listStore, tableData, queryUtility, noDataItem, linkOrderLineModal, showActions, refundOrderLineConfirmModal },
	data,
	refreshPage,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="k-grid__header--sml spc--top--sml">
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					viewStore,
					noDataItem,
					showActions,
				}}
				actions={viewStore}
			/>
			<BaasicModal modalParams={linkOrderLineModal}>
				<LinkOrderLine refreshPage={refreshPage} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicConfirmModal modalParams={refundOrderLineConfirmModal} />
		</section>
	);
};

export default defaultTemplate(OrderLinesListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderLinesListTemplate.jsx